// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3HkNh","title":"card_title__30Y6p","inActive":"card_inActive__3sp7P"};